import { HttpClient } from './types';

export const createUserAddressService = (httpClient: HttpClient) => {
  const getEndpoint = (url: string): string => `/usuarios/direcciones${url}`;

  return {
    getAllAddresses: <TAddress = any>(): Promise<TAddress[]> => {
      return httpClient.get<TAddress[]>(getEndpoint(''));
    },

    createAddress: <TAddressDTO = any, TResponse = any>(address: TAddressDTO): Promise<TResponse> => {
      return httpClient.post<TResponse>(getEndpoint(''), address);
    },

    updateAddress: <TAddressDTO = any, TResponse = any>(
      addressId: string,
      address: TAddressDTO
    ): Promise<TResponse> => {
      return httpClient.put<TResponse>(getEndpoint(`/${addressId}`), address);
    },

    deleteAddress: <TResponse = any>(addressId: string): Promise<TResponse> => {
      return httpClient.delete<TResponse>(getEndpoint(`/${addressId}`));
    },

    selectAddress: <TResponse = any>(addressId: string): Promise<TResponse> => {
      return httpClient.put<TResponse>(getEndpoint(`/${addressId}/seleccionar`), {});
    },
  };
};

